import React, { useState } from 'react';
import PageHeader from '../components/PageHeader';
import ImageWithFallback from '../components/ImageWithFallback';
import { MapPin, Calendar, Users, Filter, Search } from 'lucide-react';
import { Link } from 'react-router-dom';
const Wisata = () => {
  const [selectedRegion, setSelectedRegion] = useState('');
  const [selectedDuration, setSelectedDuration] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const destinations = [{
    id: 'dest-1',
    name: 'Japan Discovery',
    image: 'https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1374&q=80',
    location: 'Tokyo, Kyoto, Osaka',
    duration: '12 Days',
    groupSize: '15-20 People',
    startDate: 'Monthly Departures',
    price: 4599,
    description: "Immerse yourself in Japan's rich culture, history and natural beauty.",
    category: 'International',
    region: 'Asia'
  }, {
    id: 'dest-2',
    name: 'Thailand Delight',
    image: 'https://images.unsplash.com/photo-1528181304800-259b08848526?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1374&q=80',
    location: 'Bangkok, Phuket',
    duration: '7 Days',
    groupSize: '20-25 People',
    startDate: 'Weekly Departures',
    price: 1299,
    description: "Experience Thailand's vibrant culture, cuisine and beautiful beaches.",
    category: 'ASEAN',
    region: 'Southeast Asia'
  }, {
    id: 'dest-3',
    name: 'Indonesian Paradise',
    image: 'https://images.unsplash.com/photo-1512291313931-d4291048e7b6?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1374&q=80',
    location: 'Bali, Lombok',
    duration: '6 Days',
    groupSize: '15-20 People',
    startDate: 'Monthly Departures',
    price: 1499,
    description: "Relax and unwind in Indonesia's most beautiful islands.",
    category: 'ASEAN',
    region: 'Southeast Asia'
  }, {
    id: 'dest-4',
    name: 'European Highlights',
    image: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1374&q=80',
    location: 'Paris, Rome, Barcelona',
    duration: '10 Days',
    groupSize: '20-25 People',
    startDate: 'Biweekly Departures',
    price: 3899,
    description: "Explore the best of Europe's iconic cities and landmarks.",
    category: 'International',
    region: 'Europe'
  }, {
    id: 'dest-5',
    name: 'Egypt Explorer',
    image: 'https://images.unsplash.com/photo-1518684079-3c830dcef090?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1374&q=80',
    location: 'Cairo, Luxor, Aswan',
    duration: '14 Days',
    groupSize: '15-20 People',
    startDate: 'Monthly Departures',
    price: 3299,
    description: 'Discover the wonders of ancient Egypt along the Nile River.',
    category: 'International',
    region: 'Africa'
  }, {
    id: 'dest-6',
    name: 'Vietnam Heritage',
    image: 'https://images.unsplash.com/photo-1596422846543-75c6fc197f07?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1374&q=80',
    location: 'Hanoi, Ha Long Bay',
    duration: '5 Days',
    groupSize: '20-25 People',
    startDate: 'Weekly Departures',
    price: 1199,
    description: "Discover Vietnam's rich history, culture and natural wonders.",
    category: 'ASEAN',
    region: 'Southeast Asia'
  }];
  const filteredDestinations = destinations.filter(dest => {
    if (selectedRegion && dest.region !== selectedRegion) return false;
    if (selectedCategory && dest.category !== selectedCategory) return false;
    if (selectedDuration) {
      const days = parseInt(dest.duration);
      if (selectedDuration === 'short' && days >= 7) return false;
      if (selectedDuration === 'medium' && (days < 7 || days > 10)) return false;
      if (selectedDuration === 'long' && days <= 10) return false;
    }
    return true;
  });
  return <div className="w-full" data-id="element-1261">
      <PageHeader title="Wisata KU" subtitle="Explore the world with our curated travel experiences" backgroundImage="https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80" data-id="element-1262" />
      {/* Destination Categories */}
      <section className="py-10 bg-white" data-id="element-1263">
        <div className="container mx-auto px-4 md:px-8" data-id="element-1264">
          <h2 className="text-3xl font-bold text-navy-900 mb-8 text-center" data-id="element-1265">
            Popular Destinations
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-1266">
            <div className="relative group overflow-hidden rounded-lg" data-id="element-1267">
              <ImageWithFallback src="https://images.unsplash.com/photo-1542051841857-5f90071e7989?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80" alt="Japan" className="w-full h-48 object-cover transition-transform group-hover:scale-110" data-id="element-1268" />
              <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center" data-id="element-1269">
                <h3 className="text-white text-xl font-bold" data-id="element-1270">Japan</h3>
              </div>
            </div>
            <div className="relative group overflow-hidden rounded-lg" data-id="element-1271">
              <ImageWithFallback src="https://images.unsplash.com/photo-1528181304800-259b08848526?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80" alt="Thailand" className="w-full h-48 object-cover transition-transform group-hover:scale-110" data-id="element-1272" />
              <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center" data-id="element-1273">
                <h3 className="text-white text-xl font-bold" data-id="element-1274">Thailand</h3>
              </div>
            </div>
            <div className="relative group overflow-hidden rounded-lg" data-id="element-1275">
              <ImageWithFallback src="https://images.unsplash.com/photo-1502602898657-3e91760cbb34?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80" alt="Europe" className="w-full h-48 object-cover transition-transform group-hover:scale-110" data-id="element-1276" />
              <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center" data-id="element-1277">
                <h3 className="text-white text-xl font-bold" data-id="element-1278">Europe</h3>
              </div>
            </div>
            <div className="relative group overflow-hidden rounded-lg" data-id="element-1279">
              <ImageWithFallback src="https://images.unsplash.com/photo-1518684079-3c830dcef090?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80" alt="Middle East" className="w-full h-48 object-cover transition-transform group-hover:scale-110" data-id="element-1280" />
              <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center" data-id="element-1281">
                <h3 className="text-white text-xl font-bold" data-id="element-1282">Middle East</h3>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Filter Section */}
      <section className="py-8 bg-navy-50" data-id="element-1283">
        <div className="container mx-auto px-4 md:px-8" data-id="element-1284">
          <div className="flex flex-col md:flex-row md:items-end gap-4" data-id="element-1285">
            <div className="flex-1" data-id="element-1286">
              <label className="block text-sm font-medium text-navy-900 mb-2" data-id="element-1287">
                Region
              </label>
              <select value={selectedRegion} onChange={e => setSelectedRegion(e.target.value)} className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-500" data-id="element-1288">
                <option value="" data-id="element-1289">All Regions</option>
                <option value="Southeast Asia" data-id="element-1290">Southeast Asia</option>
                <option value="Asia" data-id="element-1291">Asia</option>
                <option value="Europe" data-id="element-1292">Europe</option>
                <option value="Africa" data-id="element-1293">Africa</option>
                <option value="Middle East" data-id="element-1294">Middle East</option>
              </select>
            </div>
            <div className="flex-1" data-id="element-1295">
              <label className="block text-sm font-medium text-navy-900 mb-2" data-id="element-1296">
                Duration
              </label>
              <select value={selectedDuration} onChange={e => setSelectedDuration(e.target.value)} className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-500" data-id="element-1297">
                <option value="" data-id="element-1298">Any Duration</option>
                <option value="short" data-id="element-1299">Short (1-6 days)</option>
                <option value="medium" data-id="element-1300">Medium (7-10 days)</option>
                <option value="long" data-id="element-1301">Long (11+ days)</option>
              </select>
            </div>
            <div className="flex-1" data-id="element-1302">
              <label className="block text-sm font-medium text-navy-900 mb-2" data-id="element-1303">
                Category
              </label>
              <select value={selectedCategory} onChange={e => setSelectedCategory(e.target.value)} className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-500" data-id="element-1304">
                <option value="" data-id="element-1305">All Categories</option>
                <option value="ASEAN" data-id="element-1306">ASEAN</option>
                <option value="International" data-id="element-1307">International</option>
              </select>
            </div>
            <div className="md:flex-none" data-id="element-1308">
              <button className="w-full md:w-auto bg-navy-900 hover:bg-navy-800 text-white px-8 py-3 rounded-md font-medium transition-colors flex items-center justify-center" data-id="element-1309">
                <Filter size={18} className="mr-2" data-id="element-1310" />
                Apply Filters
              </button>
            </div>
          </div>
        </div>
      </section>
      {/* Destinations Grid */}
      <section className="py-16 bg-white" data-id="element-1311">
        <div className="container mx-auto px-4 md:px-8" data-id="element-1312">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1313">
            {filteredDestinations.map(destination => <div key={destination.id} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow" data-id="element-1314">
                <div className="relative h-48" data-id="element-1315">
                  <ImageWithFallback src={destination.image} alt={destination.name} className="w-full h-full object-cover" data-id="element-1316" />
                  <div className="absolute top-4 left-4 bg-navy-900 text-white px-3 py-1 text-sm font-medium rounded" data-id="element-1317">
                    {destination.duration}
                  </div>
                </div>
                <div className="p-6" data-id="element-1318">
                  <div className="flex items-center mb-2" data-id="element-1319">
                    <MapPin size={16} className="text-gold-500 mr-1" data-id="element-1320" />
                    <span className="text-sm text-navy-600" data-id="element-1321">
                      {destination.location}
                    </span>
                  </div>
                  <h3 className="text-xl font-bold text-navy-900 mb-2" data-id="element-1322">
                    {destination.name}
                  </h3>
                  <p className="text-navy-700 mb-4 line-clamp-2" data-id="element-1323">
                    {destination.description}
                  </p>
                  <div className="flex justify-between items-center" data-id="element-1324">
                    <div data-id="element-1325">
                      <span className="text-sm text-navy-600" data-id="element-1326">FROM</span>
                      <div className="text-xl font-bold text-gold-500" data-id="element-1327">
                        ${destination.price}
                      </div>
                    </div>
                    <Link to={`/destination/${destination.id}`} className="bg-navy-900 hover:bg-navy-800 text-white px-4 py-2 rounded text-sm font-medium transition-colors" data-id="element-1328">
                      View Details
                    </Link>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>
      {/* Travel Tips */}
      <section className="py-16 bg-navy-50" data-id="element-1329">
        <div className="container mx-auto px-4 md:px-8" data-id="element-1330">
          <h2 className="text-3xl font-bold text-center text-navy-900 mb-12" data-id="element-1331">
            Travel Tips
          </h2>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-1332">
            <div className="bg-white p-6 rounded-lg shadow" data-id="element-1333">
              <h3 className="text-xl font-bold text-navy-900 mb-4" data-id="element-1334">
                Packing Essentials
              </h3>
              <ul className="space-y-2 text-navy-700" data-id="element-1335">
                <li data-id="element-1336">• Travel documents and copies</li>
                <li data-id="element-1337">• Appropriate clothing for your destination</li>
                <li data-id="element-1338">• Basic medications and first aid</li>
                <li data-id="element-1339">• Universal power adapter</li>
                <li data-id="element-1340">• Comfortable walking shoes</li>
              </ul>
            </div>
            <div className="bg-white p-6 rounded-lg shadow" data-id="element-1341">
              <h3 className="text-xl font-bold text-navy-900 mb-4" data-id="element-1342">
                Cultural Awareness
              </h3>
              <ul className="space-y-2 text-navy-700" data-id="element-1343">
                <li data-id="element-1344">• Research local customs and traditions</li>
                <li data-id="element-1345">• Learn basic phrases in the local language</li>
                <li data-id="element-1346">• Dress respectfully, especially at religious sites</li>
                <li data-id="element-1347">• Be mindful of photography restrictions</li>
                <li data-id="element-1348">• Respect local etiquette and practices</li>
              </ul>
            </div>
            <div className="bg-white p-6 rounded-lg shadow" data-id="element-1349">
              <h3 className="text-xl font-bold text-navy-900 mb-4" data-id="element-1350">
                Health & Safety
              </h3>
              <ul className="space-y-2 text-navy-700" data-id="element-1351">
                <li data-id="element-1352">• Check required vaccinations in advance</li>
                <li data-id="element-1353">• Stay hydrated, especially in warm climates</li>
                <li data-id="element-1354">• Protect yourself from sun exposure</li>
                <li data-id="element-1355">• Keep emergency contacts handy</li>
                <li data-id="element-1356">• Purchase travel insurance</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default Wisata;